import ReactApexChart from 'react-apexcharts';
import "./ChartStyle.scss"
export default function LineChartItem({data, unit, lastValue}){
  const colors = ["#8CAE68", "#FF6347","#B3679B","#FFBA49","#175676","#90A9B7","#3F292B"]
  const random = Math.floor(Math.random() * colors.length);
  const values = data.map(obj=>
    obj.value);
    const years = data.map(obj=>
      obj.year);
  const series= [{
    name: 'series1',
    data: values
  }]
  const options= {
    chart: {
      type: 'line',
      toolbar: {
        show:false,
        offsetX: 20,
        tools: {
          download: false,
          selection: false,
          zoom: false,
          
          pan: false,
          reset: false,
        }
      }
    },
    stroke: {
      width: 2,
    },
    colors: [`${colors[random]}`],
    markers: {
      size: 4,
      hover: {
        size: undefined,
        sizeOffset: 3
      }
  },
    xaxis: {
      categories: years,
      tickAmount: 7,
    },
    yaxis: {
      categories: unit,
      tickAmount: 1,
      title: {
        text: unit
      }
    }

  }

  return(
    <div id="chart">
      <ReactApexChart options={options} series={series} height="100%" type="line" />
    </div>
  );
}